import React, { Component } from "react";
import moment from "moment";
import routes from "../../routes/URL";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import Table from "../../components/Table";

import Header from "../../components/Header";
import Toast from "../../components/Toast";


class ListMenuScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toast: {
        open: false,
        message: "",
        severity: "success" 
      }
    };
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  }
  
  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    });
  }

  componentDidMount() {
    const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
  if (!hotel) {
      this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
      return;
  }
  
}

  onDelete = async (item) => {
    const { status, message, data } = await API(
      this,
      "post",
      URL_PATH.deleteUser(item.id)
    );
   
    if (status === "success") {
      this.showToast(message, "success");
      this.setState({
        version: this.state.version + Math.random() + "",
      });
    } else {
      this.showToast(message, "error");
    }
  };
  onEdit = async (item) => {
    this.props.history.push(routes.admin.users.update(this.props.hotels[0].hotel_slug,item.slug,item.id));
  };
  onView = async (item) => {
    // this.props.history.push("/floors/" + item.id);
  };


  onSwitch = async (item, value) => {
    console.log("Switch: ", item, value);
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.updateMenuStatus,
      { menu_id: item.id, status: value }
    );
  };
  render() {
    const { isModalOpen, modalType, modalTitle, modalMessage, modalButtonText } = this.state

    return (
      <div className="container-fluid">
        <Header
          title="Staff Login"
          button="NEW STAFF USER"
          // back={false}
          onclick={() => {
            this.props.history.push(routes.admin.users.create(this.props.hotels[0].hotel_slug));
          }}
        />
   <Toast
        open={this.state.toast.open}
        message={this.state.toast.message}
        severity={this.state.toast.severity}
        handleClose={this.handleCloseToast}
      />
        <Table
          key={this.state.version}
          api={URL_PATH.listUsers(this.props.selectedHotelId.id)}
          onRowClick={this.onView}
          onEdit={this.onEdit}
          onDelete={this.onDelete}
          searchPlaceholder="Search by name"
  exportFileName="Staff"  
          export={"csv"}
          // onView={this.onView}
          deleteText="delete all data related to this User."
          // onDelete={this.onDelete}
          row={[
            {
              title: "Name",
              key: "name",
              sortable: true,
            },
            {
              title: "Email(Username)",
              key: "email",
              sortable: true,
            },
            {
              title: "Mobile",
              key: "mobile",
              sortable: true,
            },
            {
              title: "Designation",
              key: "designation",
              sortable: true,
            },
          ]}
        />
       
      </div>
    );
  }
}

export default redux(ListMenuScreen);
